import axios from 'axios';
import utils from '../utils/utils';
import User from '../utils/User';
import store from '@/store/index';
import { getTimestamp, setTimestamp, removeTimestamp } from '@/utils/Cookies';
import { resetRouter } from '@/router/index.js';

axios.defaults.withCredentials = true;

// 401 防重复提示：同一时段多个接口返回 401，只弹一次提示
let last401Time = 0;
const SHOW_401_INTERVAL = 3000; // 3秒内不重复提示

function handle401() {
	const now = Date.now();
	if (now - last401Time > SHOW_401_INTERVAL) {
		last401Time = now;
		utils.showWarning('登录过期，请重新登录！');
	}
	store.dispatch('User/logout');
}

const instance = axios.create({
	// baseURL: process.env.NODE_ENV == 'development' ? process.env.VUE_APP_LHOST : process.env.VUE_APP_LHOST,
	withCredentials: true, //是否允许跨域
	timeout: 10 * 60 * 1000  // 超时时间10分钟
});

// 请求拦截
instance.interceptors.request.use(
	config => {
		store.dispatch('Settings/setError', false);
		let tk = User.getToken();
		if (tk) {
			config.headers['Authorization'] = 'Bearer ' + tk;
		}

		// 企业信息
		let cinfo = User.getCorporate();
		if (cinfo) {
			config.headers['corporate-id'] = cinfo.corporateId;
		}

		let ts = getTimestamp();
		if (ts) {
			config.headers['Temp-id'] = ts;
		} else {
			//时间戳（毫秒）+ip  生成唯一的id
			let tsNum = Math.floor(Math.random() * 10000000000);
			let timestamp = Date.now();
			let tempId = String(timestamp) + '_' + String(tsNum); //临时id
			setTimestamp(tempId);
			config.headers['Temp-id'] = tempId; //临时id
		}

		// console.log('请求参数：', config);

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// 响应拦截
instance.interceptors.response.use(
	response => {
		if (response.status == 200) {
			const { code, msg } = response.data;
			if (code) {
				if (code == 200) {
					return response.data;
				} else if (code == 401) {
					handle401();
				} else if (code == 403) {
					console.log('403-错误信息---：', msg, response.config.url);
					utils.showWarning(msg);
					return Promise.reject();
				} else if (code == 500) {
					// utils.showWarning(msg);
					console.log('500-错误信息---：', response.data, response.config.url);
					utils.showWarning(msg + '，请联系客服！');
					return Promise.reject();
					// return Promise.reject(new Error(msg || 'Error'))
				} else {
					return response.data;
				}
			} else {
				return response.data;
			}
		}
	},
	error => {
		// utils.showWarning('请求失败，请联系客服！');
		// 此处处理 HTTP 网络错误（如超时、404、500 等）
		console.error('响应错误：', error);

		store.dispatch('Settings/setError', true);

		// 自定义错误信息
		let message = '';

		if (error.response) {
			// 服务器返回了错误状态码
			const status = error.response.status;
			switch (status) {
				case 400:
					message = '请求错误';
					break;
				case 401:
					message = '未授权，请重新登录';
					// 跳转登录页
					handle401();
					break;
				case 403:
					message = '拒绝访问';
					break;
				case 404:
					message = '请求地址不存在';
					break;
				case 408:
					message = '请求超时';
					break;
				case 500:
					message = '服务器内部错误';
					break;
				case 501:
					message = '服务未实现';
					break;
				case 502:
					message = '网关错误';
					break;
				case 503:
					message = '服务不可用';
					break;
				case 504:
					message = '网关超时';
					break;
				default:
					message = `未知错误(${status})`;
			}
		} else if (error.request) {
			// 请求已发出，但没有收到响应（网络问题）
			message = '网络异常，请检查网络连接';
		} else {
			// 请求配置出错
			message = '请求配置错误';
		}
		console.error('error-错误信息：', message);
		utils.showWarning(message + '，请联系客服！');
		return Promise.reject(message);
	}
);

export default instance;
